/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon} from '../../../helpers'
import { Link } from 'react-router-dom'
import { Skeleton } from '@mui/material'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
type Props = {
  className: string
  color: string
  svgIcon: string
  faIcon?: string
  // qwe:any
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
  skeltonLoader?:Boolean
  extra?: React.ReactNode
  customIcon?: React.ReactNode
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  faIcon,
  iconColor,
  title,
  // qwe,
  titleColor,
  description,
  descriptionColor,
  skeltonLoader,
  extra,
  customIcon
}) => {

  const {mode} = useThemeMode();

  // console.log("modevhsdvhsdhd",mode)
  return (
    <div className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
       { !skeltonLoader ?
        <>
          <Skeleton
            variant="circular"
            width={40}
            height={38}
            // animation="wave"
            sx={(theme) => ({
              bgcolor: mode === "dark" ? "#3a3a55" : undefined,
            })}
            style={{ marginBottom: 13 }}
          />

          <Skeleton
            variant="rectangular"
            height={36}
            // animation="wave"
            sx={(theme) => ({
              bgcolor: mode === "dark" ? "#3a3a55" : undefined ,
            })}
            style={{ marginBottom: 7 }}
          />

          <Skeleton
            variant="text"
            // animation="wave"
            sx={(theme) => ({
              fontSize: "1rem",
              bgcolor: mode === "dark" ? "#3a3a55" : undefined,
            })}
          />
        </>
        : 
        <>
      {customIcon ? customIcon : faIcon ? (
        <i
          className={`fas ${faIcon} text-${iconColor} ms-n1`}
          style={{fontSize: 32, width: 37, height: 37, lineHeight: '37px', display: 'inline-block', paddingLeft: "6px"}}
        />
      ) : (
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />
      )}
        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{title}</div>
        <div className={`fw-semibold text-${descriptionColor}`}>{description}</div>
        {extra}
        </>
        }

           {/* <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />
        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{title}</div>
        <div className={`fw-semibold text-${descriptionColor}`}>{description}</div> */}
      </div>
    </div>
  )
}

export {StatisticsWidget5}
